import React from "react";
import { useToggle } from "../hooks";

type Props = {
  children: React.ReactNode;
  name: string;
  storageKey?: string;
};

const ToggleSection: React.FC<Props> = ({ name, children, storageKey }) => {
  const [isOpen, toggleOpen] = useToggle(false, storageKey);

  return (
    <>
      <p>
        <a onClick={toggleOpen}>
          {isOpen ? "Close" : "Open"} {name}
        </a>
      </p>

      {isOpen && children}
    </>
  );
};

export default ToggleSection;
